









import { Component, Vue } from 'vue-property-decorator';
import Leaflets from '@/components/Leaflets.vue';
import QRCode from '@/components/QRCode.vue';
import Navbar from '@/components/Navbar.vue';
import ExInformation from '@/components/ExInformation.vue';

@Component({
  components: {
    Leaflets,
    QRCode,
    ExInformation,
    Navbar
  }
})
export default class SplitTrain extends Vue {}
